module.exports = __webpack_public_path__ + "img/250460827_2025_1-3.9c0992e6.png";